'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { EntityAvatar } from '@/components/ui/avatar/entity-avatar';
import { CartItem } from '@/types/cart.types';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { professionalDisplayName } from '@/utils/formatters/professional-name';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';
import { Typography } from '@/components/ui/typography/typography.component';

interface CartItemHeaderProps {
  item: CartItem;
}

export function CartItemHeader({ item }: CartItemHeaderProps) {
  const { professional, partner } = item;

  const name = professional
    ? professionalDisplayName({
        honorific: professional.honorific,
        name: professional.socialName || professional.legalName,
      })
    : formatToTitleCase(partner.socialName);

  const avatar = professional ? professional.avatar : partner.avatar;
  const entityType = professional
    ? EntityTypeEnum.PROFESSIONAL
    : EntityTypeEnum.LABORATORY_COLLECT_POINT;

  return (
    <div className="flex items-center gap-2" data-testid={DataTestIdEnum.CART_ITEM_PROFESSIONAL}>
      <EntityAvatar
        type={entityType}
        src={avatar}
        alt={name}
        size="lg"
        width={56}
        height={56}
        className="h-14 w-14 shrink-0 object-cover"
      />

      <Typography className="text-base font-bold leading-6 text-gray-700">{name}</Typography>
    </div>
  );
}
